import { render, staticRenderFns } from "./Creationcontenu.vue?vue&type=template&id=f97e6c9a&"
import script from "./Creationcontenu.vue?vue&type=script&lang=js&"
export * from "./Creationcontenu.vue?vue&type=script&lang=js&"
import style0 from "./Creationcontenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports